import {type PropsWithChildren, useState} from 'react'
import {Button} from '@mantine/core'

type Props = {
  minHeight: number
} & PropsWithChildren

export const PartlyCollapse = ({minHeight, children}: Props) => {
  const [innerHeight, setInnerHeight] = useState<number>(0)
  const [expanded, setExpanded] = useState<boolean>(false)
  const canOverflow = innerHeight > minHeight

  return (
    <div
      style={{
        position: 'relative',
      }}
    >
      <div
        ref={(ref) => setInnerHeight(ref?.scrollHeight || 0)}
        style={{
          maxHeight: expanded ? innerHeight : minHeight,
          transition: 'max-height .2s',
          overflow: 'hidden',
          maskImage: canOverflow && !expanded ? 'linear-gradient(180deg, #000 25%, transparent)' : undefined,
          paddingBottom: canOverflow ? 25 : undefined,
        }}
      >
        {children}
      </div>

      {canOverflow && (
        <Button
          variant={'transparent'}
          size={'compact-xs'}
          fw={'normal'}
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            textAlign: 'center',
          }}
          onClick={() => setExpanded((fullDescription) => !fullDescription)}
        >
          {expanded ? 'show less' : 'show more'}
        </Button>
      )}
    </div>
  )
}
